var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpretorStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2565_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5407 15.8914L12.7041 11.0549L17.5407 6.21838L16.1588 4.83651L11.3223 9.67303L6.48572 4.83651L5.10385 6.21838L9.94039 11.0549L5.10385 15.8914L6.48572 17.2733L11.3223 12.4368L16.1588 17.2733L17.5407 15.8914Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2565_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.634,
    height: 15.634,
    fill: "white",
    transform: "matrix(0.707109 0.707104 -0.707109 0.707104 11.3223 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpretorStarIcon);
export default __webpack_public_path__ + "static/media/opretor_star_icon.3549b572a7b40f6aecf0b54a5e0fbb23.svg";
export { ForwardRef as ReactComponent };